import React from 'react';
import { Shield } from 'lucide-react';

const PrivacyPolicy = () => {
    const privacySteps = [
        {
            id: 1,
            title: "Data yang kami kumpulkan",
            details: [
                "Nama, email, dan nomor telepon untuk pendaftaran akun",
                "Data lokasi untuk layanan pemesanan dan navigasi",
                "Data akun untuk keperluan autentikasi dan keamanan",
            ],
        },
        {
            id: 2,
            title: "Penggunaan data",
            details: [
                "Pengguna berumur diatas 13 tahun",
                "Data digunakan hanya untuk menjalankan dan meningkatkan layanan DigJek",
                "Data tidak dibagikan ke pihak ketiga tanpa izin pengguna, kecuali diwajibkan oleh hukum",
            ],
        },
        {
            id: 3,
            title: "Penggunaan Lokasi Latar Belakang (Background Location)",
            details: [
                "DigJek mengakses data lokasi pengguna meskipun aplikasi tidak sedang digunakan (background)",
                "Lokasi digunakan untuk melacak posisi driver dan customer secara real-time",
                "Digunakan untuk menghitung estimasi penjemputan dan meningkatkan akurasi layanan",
                "Akses lokasi latar belakang hanya diaktifkan setelah pengguna memberikan izin secara eksplisit",
                "Pengguna dapat menonaktifkan izin lokasi latar belakang kapan saja melalui pengaturan perangkat",
            ],
        },
        {
            id: 4,
            title: "Hak pengguna",
            details: [
                "Mengakses, memperbarui, dan menghapus data pribadi",
                "Menarik persetujuan penggunaan data kapan saja",
            ],
        },
    ];

    return (
        <div className="bg-white p-6 mt-8 rounded-lg shadow">
            <div className="flex items-center gap-3 mb-4">
                <Shield className="w-6 h-6 text-blue-600" />
                <h1 className="text-2xl font-semibold text-gray-800">
                    Kebijakan Privasi Aplikasi DigJek
                </h1>
            </div>

            <p className="text-gray-600 mb-2">
                Aplikasi DigJek dikembangkan dan dikelola oleh <strong>Hairul Dev</strong>.
            </p>
            <p className="text-gray-600 mb-6">
                Email kontak: <strong>digjek.app@gmail.com</strong>
            </p>

            <p className="text-gray-600 mb-6">
                DigJek menghargai privasi pengguna dan berkomitmen untuk melindungi data pribadi
                sesuai dengan peraturan yang berlaku.
            </p>

            {privacySteps.map((step) => (
                <div key={step.id} className="mb-6">
                    <h2 className="text-lg font-semibold text-gray-800 mb-2">
                        {step.title}
                    </h2>
                    <ul className="list-disc list-inside text-gray-700 space-y-2">
                        {step.details.map((detail, index) => (
                            <li key={index}>{detail}</li>
                        ))}
                    </ul>
                </div>
            ))}

            <p className="text-gray-600 mt-6">
                Permintaan terkait data pribadi dapat dikirim melalui email ke{" "}
                <strong>digjek.app@gmail.com</strong>.
            </p>

            <p className="text-gray-500 text-sm mt-2">
                Kebijakan privasi ini berlaku sejak 1 Januari 2025.
            </p>
        </div>
    );
};

export default PrivacyPolicy;
